import { render, staticRenderFns } from "./CarouselCourseComboItem.vue?vue&type=template&id=fc81c5ea&scoped=true"
import script from "./CarouselCourseComboItem.vue?vue&type=script&lang=js"
export * from "./CarouselCourseComboItem.vue?vue&type=script&lang=js"
import style0 from "./CarouselCourseComboItem.vue?vue&type=style&index=0&id=fc81c5ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc81c5ea",
  null
  
)

export default component.exports